"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const valueIsConstant_1 = __importDefault(require("./valueIsConstant"));
const valueIsOneOfAssertions_1 = __importDefault(require("./valueIsOneOfAssertions"));
const valueIsControlsColorSpecificationShade = (0, valueIsOneOfAssertions_1.default)([
    (0, valueIsConstant_1.default)(50),
    (0, valueIsConstant_1.default)(100),
    (0, valueIsConstant_1.default)(200),
    (0, valueIsConstant_1.default)(300),
    (0, valueIsConstant_1.default)(400),
    (0, valueIsConstant_1.default)(500),
    (0, valueIsConstant_1.default)(600),
    (0, valueIsConstant_1.default)(700),
    (0, valueIsConstant_1.default)(800),
    (0, valueIsConstant_1.default)(900),
    (0, valueIsConstant_1.default)('A100'),
    (0, valueIsConstant_1.default)('A700'),
]);
exports.default = valueIsControlsColorSpecificationShade;
